import SpiderLibrary from '../SpiderLibrary/SpiderLibrary';
import CrawlCostEstimator from '../CrawlCostEstimator/CrawlCostEstimator';
import styles from "./Dashboard.module.css"

const Dashboard = (props) => {
    return (
        <div className={styles.dashboard}>

            <div className={styles.dashCard}>
                <div>
                    <SpiderLibrary/>
                </div>

            </div>
            <div className={styles.dashCard}>
                <CrawlCostEstimator/>
            </div>
        </div>
    )
};

export default Dashboard;